import { lazyScreen } from '@croissants/ui';

/**
 * The screens past the shelf, each its own chunk (docs/portal-latency-audit.html,
 * eighth pass). The scan, the landing states, the shop chooser and the shelf
 * stay in the entry chunk: they are what a scan opens, and a guest holding a
 * phone in a Paris apartment should not wait on a second request to see the
 * croissants.
 *
 * Everything here is fetched in the background once the shelf is up
 * (`AFTER_THE_SHELF`, asked by `Menu` and `Shops`), in the order a guest
 * reaches it - the basket and the review first - so pressing the cart finds
 * the next screen in memory and `lazyScreen` renders it with no fallback. A
 * cold link straight to an order (a text message, the 3-D Secure return)
 * shows the app's own loading line for as long as that one chunk takes.
 */
export const Basket = lazyScreen(async () => (await import('./Basket')).Basket);
export const Checkout = lazyScreen(async () => (await import('./Checkout')).Checkout);
export const Windows = lazyScreen(async () => (await import('./Windows')).Windows);
export const OrderDetail = lazyScreen(async () => (await import('./OrderDetail')).OrderDetail);
export const Orders = lazyScreen(async () => (await import('./Orders')).Orders);
export const Support = lazyScreen(async () => (await import('./Support')).Support);
export const LegalPage = lazyScreen(async () => (await import('./LegalPage')).LegalPage);

/** In the order a guest reaches them from the shelf. */
export const AFTER_THE_SHELF = [Basket, Checkout, Windows, OrderDetail, Orders, Support] as const;
